import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Grid,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";

const useStyles = makeStyles(() => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
}));

const UsedByDialog = ({ data, open, handleClose }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-keyDetailas"
      aria-describedby="alert-keyDetailas"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          اطلاعات کاربر
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} md={6}>
            <Typography color="primary" style={{ marginBottom: "8px" }}>
              نام:
            </Typography>
            <Typography> {data?.fullName}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography color="primary" style={{ marginBottom: "8px" }}>
              کد ملی:
            </Typography>
            <Typography> {data?.nationalCode}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography color="primary" style={{ marginBottom: "8px" }}>
              کدپرسنلی:
            </Typography>
            <Typography> {data?.personnelCode}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography color="primary" style={{ marginBottom: "8px" }}>
              تلفن:
            </Typography>
            <Typography> {data?.phone}</Typography>
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" autoFocus>
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UsedByDialog;
